/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const common = {
  common: {
    cancel: 'Cancelar',
    delete: 'Borrar',
    remove: 'Eliminar',
    edit: 'Editar',
    restore: 'Restaurar',
    back: 'Atrás',
    submit: 'Enviar',
    continue: 'Continuar',
    save: 'Guardar',
    done: 'Hecho',
    home: 'Página De Inicio',
    noData: 'No hay datos.',
    confirm: 'Confirmar',
    más: 'más',
    close: 'Cerrar',
    loading: 'Carga',
    menu: 'Menú',
    reset: 'Restablecimiento',
    search: 'Buscar',
    add: 'Agregar',
    breadcrumbs: 'pan rallado',
    selectFile: 'Seleccionar archivo',
    clear: 'Claro',
    loaded: 'Claro',
    results: 'Resultados',
    of: 'de',
  },
  pageMetaResolver: {
    category: {
      title: '{{count}} resultado para {{query}}',
      title_other: '{{count}} Resultados para {{query}}',
    },
    checkout: {
      title: 'Caja',
    },
    search: {
      title: '{{count}} result for "{{query}}"',
      title_other: '{{count}} results for "{{query}}"',
      findProductTitle: '{{count}} result for coupon "{{coupon}}"',
      findProductTitle_other: '{{count}} results for coupon "{{coupon}}"',
      default_title: 'Todos los productos',
    },
    product: {
      description: '{{description}}',
      heading: '{{heading}}',
      title: '{{title}}',
    },
  },
  spinner: {
    loading: 'Carga...',
  },
  navigation: {
    categoryNavLabel: 'Menú de categorías',
    footerNavLabel: 'Enlaces de pie de página',
    navigateTo: 'Navega a {{nav}}',
    scrollToTop: 'Desplázate hacia atrás hasta la parte superior de la página',
  },
  searchBox: {
    placeholder: 'Estoy Buscando...',
    productBuscar: 'Buscar un producto',
    ariaLabelInput: 'Buscar aquí...',
    ariaLabelSuggestions: 'Sugerencias de mecanografía',
    ariaLabelProducts: 'Resultados del producto',
    initialDescription:
      'Cuando los resultados de autocompletar estén disponibles, use las flechas hacia arriba y hacia abajo para revisar e ingresar para seleccionar. Los usuarios de dispositivos táctiles pueden explorar de forma táctil o con gestos de deslizamiento.',
    suggestionsResult: '{{ count }} sugerencia y ',
    suggestionsResult_other: '{{ count }} sugerencias y ',
    productsResult: '{{ count }} El producto está disponible.',
    productsResult_other: '{{ count }} Los productos están disponibles.',
    resetLabel: 'Restablecimiento Buscar',
    help: {
      insufficientChars: 'Por favor, escriba más caracteres',
      noMatch: 'No se pudo encontrar ningún resultado',
      exactMatch: '{{ term }}',
      empty: 'Pregúntanos lo que quieras',
    },
  },
  sorting: {
    date: 'Fecha',
    orderNumber: 'Número de pedido',
    rma: 'Número de devolución',
    replenishmentNumber: 'Número de reposición',
    nextOrderFecha: 'Fecha de Siguiente Orden',
    pageViewUpdated: 'La vista de página se ha actualizado con las opciones seleccionadas.',
  },
  httpHandlers: {
    badRequest: {
      bad_credentials: 'Malas credenciales. Por favor, inicie sesión de nuevo.',
      user_is_disabled: 'El usuario está deshabilitado. Póngase en contacto con la administración.',
    },
    badGateway: 'Se ha producido un error del servidor. Por favor, inténtelo de nuevo más tarde.',
    badRequestPleaseLoginAgain: '{{ errorMessage }}. Por favor, inicie sesión de nuevo.',
    badRequestOldPasswordIncorrect: 'La contraseña antigua es incorrecta.',
    badRequestGuestDuplicateEmail:
      '{{ errorMessage }} correo electrónico ya existen. Realice el pago con un correo electrónico diferente para registrarse con una cuenta de invitado.',
    conflict: 'Ya existe.',
    forbidden:
      'Usted no está autorizado a realizar esta acción. Póngase en contacto con su administrador si cree que se trata de un error.',
    gatewayTimeout: 'El servidor no respondió, inténtelo de nuevo más tarde.',
    internalServerError:
      'Se ha producido un error interno del servidor. Por favor, inténtelo de nuevo más tarde.',
    sessionExpired: 'Su sesión ha caducado. Por favor, inicie sesión de nuevo.',
    unknownError: 'Se ha producido un error desconocido',
    unauthorized: {
      common: 'Se ha producido un error de autorización desconocido',
      invalid_client: 'Credenciales de cliente incorrectas',
    },
    validationErrors: {
      missing: {
        card_cardType:
          'La tarjeta de crédito seleccionada no es compatible. Por favor, seleccione otro.',
        card_accountNumber: 'El número de tarjeta de crédito introducido no es válido.',
        card_cvNumber: 'El código de seguridad introducido no es válido.',
        card_expirationMonth:
          'La fecha de vencimiento de la tarjeta de crédito ingresada no es válida.',
        card_expirationYear:
          'La fecha de vencimiento de la tarjeta de crédito ingresada no es válida.',
        billTo_firstName: 'El nombre introducido no es válido.',
        billTo_lastName: 'El apellido introducido no es válido.',
        billTo_street1: 'La dirección introducida no es válida.',
        billTo_street2: 'La dirección introducida no es válida.',
        billTo_city: 'La ciudad introducida no es válida para esta tarjeta de crédito.',
        billTo_state:
          'The state/province entered is not valid for this credit card.',
        billTo_country:
          'The country/region entered is not valid for this credit card.',
        billTo_postalCode:
          'The zip/postal code is not valid for this credit card.',
        country: {
          isocode: 'Missing country/region',
        },
      },
      invalid: {
        card_expirationMonth:
          'La fecha de vencimiento de la tarjeta de crédito ingresada no es válida.',
        firstName: 'El nombre ingresado no es válido.',
        lastName: 'El apellido ingresado no es válido.',
        password: 'La contraseña introducida no es válida.',
        uid: 'El UID no es válido.',
        code: 'El código no es válido.',
        email: 'El correo electrónico no es válido.',
      },
    },
    cartNotFound: 'Carrito no encontrado.',
    invalidCodeProvided: 'Se ha proporcionado un código no válido.',
    voucherExceeded:
      'Este cupón ha superado el número de veces que se puede utilizar',
    unknownIdentifier: 'Artículo no encontrado.',
    otherCartErrors: 'Se han producido errores en el carrito.',
  },
  miniCart: {
    item: '{{count}} Artículo actualmente en tu carrito',
    item_other: '{{count}} Artículos actualmente en su carrito',
    total: '{{total}}',
    count: '{{count}}',
    entries: 'artículos'
  },
  skipLink: {
    skipTo: 'Saltar a',
    labels: {
      header: 'Encabezado',
      main: 'Contenido principal',
      footer: 'Pie de página',
      productFacets: 'Facetas del producto',
      productList: 'Lista de productos',
    },
  },
  carousel: {
    previousSlide: 'Diapositiva anterior',
    nextSlide: 'Siguiente diapositiva',
    slideNumber: 'Diapositiva {{currentSlideNumber}}',
    carouselForProduct: 'Carrusel, Imágenes para {{product}}',
  },
  formErrors: {
    globalMessage: 'El formulario que está intentando enviar contiene errores.',
    required: 'Este campo es obligatorio',
    cxInvalidEmail: 'Este no es un formato de correo electrónico válido',
    cxInvalidPassword: 'Este no es un formato de contraseña válido',
    cxPasswordsMustMatch: 'Los campos de contraseña deben coincidir',
    cxEmailsMustMatch: 'Los campos de correo electrónico deben coincidir',
    cxStarRatingEmpty: 'El campo de clasificación es obligatorio',
    cxNoSelectedItemToCancelar: 'Seleccione al menos un elemento',
    cxNegativeAmount: 'La cantidad debe ser igual o mayor que cero',
    cxContainsSpecialCharacters: 'El campo no puede contener caracteres especiales',
    date: {
      required: 'Este campo es obligatorio',
      min: 'La fecha no puede ser anterior a {{min}}',
      max: 'La fecha no puede ser después de {{max}}',
      pattern: 'Usar formato de fecha aaaa-mm-dd',
      invalid: 'Usa una fecha válida',
    },
    file: {
      required: 'Se requiere un archivo',
      empty: 'El archivo no debe estar vacío',
      invalidExtension: 'La extensión de archivo no es válida',
      tooLarge: 'El tamaño del archivo no debe exceder {{ maxSize }} MB',
      tooManyEntries: 'El número de artículos es mayor que {{ maxEntries }}',
      notParsable: 'El archivo no se puede analizar',
      fileNotAllowed: 'Este tipo de archivo no está permitido',
    },
  },
  errorHandlers: {
    scriptFailedToLoad: 'No se pudo cargar el script.',
    refreshThePage: 'Por favor, actualice la página.',
  },
  assistiveMessage: {
    actionCancelarled: 'Acción cancelada, nada cambió',
  },
  passwordVisibility: {
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
  },
  generalErrors: {
    pageFailure: 'No se ha podido cargar la página. Por favor, inténtelo de nuevo más tarde.',
  },
  chatMessaging: {
    charactersLeft: 'Caracteres a la izquierda: {{count}}',
    addNewMessage: 'Agregar Nuevo Mensaje',
    send: 'Enviar',
    uploadFile: 'Subir archivo',
    informationLabel: '{{author}}. {{text}} en {{date}}',
    messages: 'Mensajes',
    addMessagePlaceHolder: 'Empieza a escribir...',
    characterLimitAlert: 'Se ha alcanzado el límite de caracteres.',
  },
};
